export default "__VITE_ASSET__5c7fa661__"